<!-- @format -->

@if (inventoryExceededText()) {
	<div class="hmf-mb-m">
		<hmf-alert-banner
			messageType="warning"
			[messageTitle]="inventoryExceededText()"
			[displayIcon]="false"
		></hmf-alert-banner>
	</div>
} @else if (maxOrMinQuantityAlert()) {
	<div class="hmf-mb-m">
		<hmf-alert-banner
			messageType="warning"
			[messageTitle]="maxOrMinQuantityAlert()"
			[displayIcon]="false"
		></hmf-alert-banner>
	</div>
}
